import { createAsyncThunk } from '@reduxjs/toolkit';
import { Context } from '@wix/wix-chatbot-common/browser';

import { IInitialChatData } from '../../../server/service/InitialChatData';
import { widgetSDK } from '../../sdk/widgetSDK';
import { chatbotStartChat } from '../api/chatbotStartChat';
import { TRootState } from '../reducers';

export type StartChatParams = Record<string, string>;

type StartChatArgs = {
  context: Context;
  editorType?: string;
  params?: StartChatParams;
};

export const loadChatbotStartChat = createAsyncThunk<IInitialChatData, StartChatArgs, { state: TRootState }>(
  'loadChatbotStartChat',
  async ({ context, editorType, params: paramsOverride }, { getState }) => {
    const state = getState();
    const startChatParams = state.chat.startChatParameters || (await widgetSDK.getStartChatParams());
    const params = {
      ...startChatParams,
      ...(editorType ? { editorType } : {}),
      ...paramsOverride,
    };
    return chatbotStartChat(params, context);
  },
);
